<template>
    <Checkout current-page="Personal Info">
        <h2 class="checkoutTitle">Customer Information</h2>
        <true-panel class="customerInfoBox"
                    :shadow="false">
            <form method="post">
                <!-- <input autocomplete="false" name="hidden" type="text" style="display:none;"> -->
                <div class="formGroup">
                    <label for="">First and Last Name</label>
                    <input type="text"
                           placeholder="First and Last Name"
                           v-model="lead.name" />
                </div>
                <div class="formGroup">
                    <label for="" ref="addressLabel">&nbsp;</label>
                    <GmapAutocomplete @place_changed="getAddressData"
                                      ref="autocomplete"
                                      :value="lead.place.formatted_address"
                                      placeholder="" />
                    <label class="fauxLabel">Address</label>
                </div>
                <div class="formGroup">
                    <label for="">Email</label>
                    <input type="email"
                           placeholder="joe@example.com"
                           v-model="lead.email" />
                </div>
                <div class="formGroup">
                    <label for="">Phone</label>
                    <input type="tel"
                           v-mask="'(###) ###-####'"
                           placeholder="555-555-5555"
                           v-model="lead.phone" />
                </div>
                <p>
                    After completing your order, we will give you a call to schedule the installation. We will also send you an email with confirmation information.
                </p>
            </form>
        </true-panel>

        <transition name="fade">
            <true-panel class="googleMapCard"
                        :shadow="false"
                        v-if="placeSelected">
                <div class="googleMapCard-contact">
                    <div>{{ lead.name }}</div>
                    <div>{{ address }}</div>
                    <div>{{ city }}, {{ state }} {{ zip }}</div>
                </div>
                <GmapMap style="width: 303px; height: 185px;"
                         :zoom="12"
                         :center="latLng">
                    <GmapMarker label="★"
                                :position="latLng" />
                </GmapMap>
            </true-panel>
        </transition>

        <transition name="fade">
            <continue-button v-if="readyToContinue"
                             :before="mixpanelTracking"
                             to="/checkout/payment"
                             text="Continue to payment info" />
        </transition>

    </Checkout>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import store from '../store'
import Checkout from './Checkout.vue'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
export default {
    data() {
        return {
            // place: null
        }
    },
    computed: {
        ...mapState(['lead', 'system']),
        ...mapGetters(['latLng', 'city', 'state', 'address', 'zip']),

        placeSelected() {
            return this.lead.place ? Object.keys(this.lead.place).length : false
        },

        readyToContinue() {
            let name = this.lead.name
            let email = this.lead.email
            let phone = this.lead.phone

            if (name && email && phone && this.placeSelected) {
                return true
            }

            return false
        }
    },
    methods: {
        ...mapActions(['setPlace', 'save']),
        getAddressData(data) {
            this.setPlace(data)
        },

        mixpanelTracking() {
            mixpanel.track("checkoutStep2Complete")
        }
    },
    components: {
        Checkout,
        VueGoogleAutocomplete
    },
    mounted() {
        // console.log(this.$refs.autocomplete.$refs)
        // this.$watch('lead', (lead) => {
        //     this.place = lead.place
        // })

        window.setTimeout(() => {
            // this.$refs.addressLabel.textContent = 'Address'
        }, 300)
    },
    updated() {}
}
</script>

<style lang="css"></style>
